import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { CarUiRow } from '../types/carTable.types'

export const carTableColumns: ColumnDefinition<CarUiRow>[] = [
  {
    key: 'CarID',
    title: 'מזהה',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'CarNum',
    title: 'מספר רכב',
    dataType: 'number',
    width: '100px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'FreightCompanyID',
    title: 'חברת הובלה',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in CarTableModule.tsx
  },
  {
    key: 'DriverWorkerId',
    title: 'עובד נהג',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in CarTableModule.tsx
  },
  {
    key: 'DriverName',
    title: 'שם נהג',
    dataType: 'string',
    width: '140px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Phone',
    title: 'טלפון',
    dataType: 'string',
    width: '120px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'DriverID',
    title: 'מזהה נהג',
    dataType: 'number',
    width: '100px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Max_Weight',
    title: 'משקל מקסימלי',
    dataType: 'number',
    width: '110px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pallets',
    title: 'משטחים',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'EmptyTrackWght',
    title: 'משקל רכב ריק',
    dataType: 'number',
    width: '120px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'IsChargeHovala',
    title: 'חיוב הובלה',
    dataType: 'boolean',
    width: '100px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
]
